import { Routes } from "@angular/router";
import { NeshImagensResolver } from "./modules/nesh/nesh-imagens/nesh-imagens.resolver";
import { possuiPerfilGestorGuard } from "./core/guards/possui-perfil-gestor.guard";

export const APP_ROUTES: Routes = [
  {
    path: "",
    // title: "",
    redirectTo: "sumario",
    pathMatch: "full",
   },
  {
    path: "ajuda",
    loadComponent: () =>
      import("./modules/ajuda/ajuda-usuario/ajuda-usuario.component").then(
        (c) => c.AjudaUsuarioComponent,
      ),
    // title: "Manual do Usuário",
  },
  {
    path: "ajudaGestor",
    loadComponent: () =>
      import("./modules/ajuda/ajuda-gestor/ajuda-gestor.component").then(
        (c) => c.AjudaGestorComponent,
      ),
    // title: "Manual do Gestor",
  },
  {
    path: "ajudaClassif",
    loadComponent: () =>
      import("./modules/ajuda/ajuda-classif/ajuda-classif.component").then(
        (c) => c.AjudaClassifComponent,
      ),
    // title: "Orientações sobre o Classif",
    data: { titulo: "Orientações sobre o Classif" },
  },
  {
    path: "alertas",
    loadComponent: () =>
      import("./modules/alertas/alertas.component").then(
        (c) => c.AlertasComponent,
      ),
    // title: "Alertas do Gestor",
    data: { titulo: "Alertas do Gestor" },
  },
  {
    path: "avisos",
    loadChildren: () =>
      import("./modules/avisos/avisos.routes").then((r) => r.AVISOS_ROUTES),
  },
  {
    path: "busca-ncm",
    loadComponent: () =>
      import("./modules/busca-ncm/busca-ncm.component").then(
        (c) => c.BuscaNcmComponent,
      ),
    // title: "Busca de NCM",
  },
  {
    path: "carga",
    loadChildren: () =>
      import("./modules/carga/carga.routes").then((r) => r.CARGA_ROUTES),
  },
  {
    path: "cotacoes",
    loadComponent: () =>
      import("./modules/cotacoes/cotacoes.component").then(
        (c) => c.CotacoesComponent,
      ),
    // title: "Cotações de Moedas",
  },
  {
    path: "cuci",
    loadChildren: () =>
      import("./modules/cuci/cuci.routes").then(
        (r) => r.CUCI_ROUTES,
      ),
  },
  {
    path: "decisoes",
    loadChildren: () =>
      import("./modules/decisoes/decisoes.routes").then(
        (r) => r.DECISOES_ROUTES,
      ),
  },
  {
    path: "decisoes-consulta",
    loadChildren: () =>
      import("./modules/decisoes-consulta/decisoes-consulta.routes").then(
        (r) => r.DECISOES_CONSULTA_ROUTES,
      ),
  },
  {
    path: "minuta",
    loadChildren: () =>
      import("./modules/minuta/minuta.routes").then((r) => r.MINUTA_ROUTES),
  },
  {
    path: "nesh-imagens",
    loadComponent: () =>
      import("./modules/nesh/nesh-imagens/nesh-imagens.component").then(
        (c) => c.NeshImagensComponent,
      ),
    // title: "Manutenção de Imagens da Nesh",
    resolve: {
      listaImagens: NeshImagensResolver,
    },
  },
  {
    path: "nesh",
    loadChildren: () =>
      import("./modules/nesh/nesh.routes").then((r) => r.NESH_ROUTES),
  },
  {
    path: "nomenclatura",
    loadChildren: () =>
      import("./modules/nomenclatura/nomenclatura.routes").then(
        (r) => r.NOMENCLATURA_ROUTES,
      ),
  },
  {
    path: "nota",
    loadChildren: () =>
      import("./modules/nota/nota.routes").then((r) => r.NOTA_ROUTES),
  },
  {
    path: "relatorio",
    loadChildren: () =>
      import("./modules/relatorio/relatorio.routes").then(
        (r) => r.RELATORIO_ROUTES,
      ),
  },
  {
    path: "rgi",
    loadChildren: () =>
      import("./modules/rgi/rgi.routes").then((r) => r.RGI_ROUTES),
  },
  {
    path: "sumario",
    loadChildren: () =>
      import("./modules/sumario/sumario.routes").then((r) => r.SUMARIO_ROUTES),
  },
  {
    path: "tabela",
    loadChildren: () =>
      import("./modules/tabela/tabela.routes").then((r) => r.TABELA_ROUTES),
  },
  {
    path: "codigo-fechado",
    loadChildren: () =>
      import("./modules/codigo-fechado/codigo-fechado.routes").then(
        (r) => r.CODIGO_FECHADO_ROUTES,
      ),
  },
  {
    path: "compendio",
    loadChildren: () =>
      import("./modules/ceclam/ceclam.routes").then((r) => r.CECLAM_ROUTES),
  },
  {
    path: "ume",
    loadChildren: () =>
      import("./modules/ume/ume.routes").then((r) => r.UME_ROUTES),
    canMatch: [possuiPerfilGestorGuard],
    runGuardsAndResolvers: "always"
  },
];
